module.exports = __webpack_public_path__ + "static/media/paquery-logo.9a9b11ed.png";